module.exports = __webpack_public_path__ + "img/retro_sec1.b822c9ff.jpg";